export function nestedVersionCheck(deluge) {
  const versionString = deluge?.info?.version_number;
  if (!versionString) {
    return false;
  }

  const [major, minor] = versionString.split('.').map(Number);

  if (major > 2 || (major === 2 && minor >= 3)) {
    return true;
  } else {
    return false;
  }
}
